import React, { ReactNode } from 'react';
import { arrowLeft } from '../../../assets/icons';
import Card from '../../../components/elements/Card';
import { T } from 'react-translator-component';

interface StakeWidgetProps {
  children: ReactNode;
  title?: string;
  onClick?: () => void;
}

const StakeWidget: React.FC<StakeWidgetProps> = ({
  children,
  title,

  onClick,
}) => {
  return (
    <Card>
      <div className="flex items-center mb-5">
        {onClick ? (<div className="mr-4">
          <button onClick={onClick}>
            <img src={arrowLeft} alt="Arrow left" />
          </button>
        </div>) : ''}

        <div>
          <h2 className="text-lg text-white">{T(title || 'Your Stake')}</h2>
        </div>
      </div>
      <div className="mb-5">{children}</div>
    </Card>
  );
};

export default StakeWidget;
